{
  "en": {
    "imports": {
      "searchPlaceholder": "Name...",
      "selectedCount": "no item selected | {count} selected | {count} selected",
      "cancel": "Cancel",
      "confirm": "Select",
      "discard": {
        "question": "Discard selection?",
        "continue": "Continue adding",
        "confirm": "Discard"
      },
      "tabWithCount": "{label} ({count})",
      "tabMatches": "{label}: no results | {label}: {count} result | {label}: {count} results",
      "contentList": {
        "leaveFolder": "Back from folder \"{name}\"",
        "openFolder": "Open folder \"{name}\"",
        "loading": "Loading content",
        "noResults": {
          "title": "No results for “{query}” here",
          "text": "Try a different search term"
        }
      },
      "loadMore": "Load more",
      "submitFailed": "Import failed. Please try again.",
      "upload": {
        "addMore": "Select more files",
        "dropFiles": "Drag & drop files here or select them.",
        "interrupted": "An upload was cancelled. Please upload the file again.",
        "removeFile": "Remove “{name}”",
        "uploaded": "Upload successful.",
        "wrongType": "This file type is not supported."
      },
      "toTeach": {
        "modalTitle": "Import to teach worksheets",
        "menuItem": "Import from to teach",
        "importedBadge": "Imported from to teach",
        "link": {
          "title": "Link account",
          "body": "Your account is not yet linked with to teach. Connect your account to use your to teach content on fobizz.",
          "confirm": "to teach"
        },
        "worksheets": {
          "tabLabel": "Your to teach account",
          "accountLink": "Your to teach account",
          "searchPlaceholder": "Search to teach worksheets",
          "empty": "No to teach worksheets found.",
          "errorLoading": "Your to teach worksheets could not be loaded.",
          "batchQueuedFlash": "Your worksheet is being imported in the background. | Your worksheet is being imported in the background. | {count} worksheets are being imported in the background."
        }
      },
      "breadcrumb": {
        "label": "Folder path",
        "more": "Show more folders"
      },
      "myContent": {
        "empty": {
          "title": "Your storage is still empty",
          "text": "Uploaded files will appear here."
        },
        "emptyFiltered": {
          "title": "No matching content",
          "text": "Adjust the filters or select “All”."
        },
        "emptyFolder": "This folder is empty.",
        "errorLoading": "Your content could not be loaded.",
        "toggleFilters": "Show filter",
        "periodLabel": "Period:",
        "noAddableContent": {
          "title": "Nothing to add here",
          "text": "These items have already been added or cannot be used here."
        }
      }
    }
  }
}
